/*
SEO status of the fields in the post config form.

Two things editors cannot see today: how long a title will be once Google
truncates it, and which head tags a post ships empty. The counter tiers and the
warning list here answer both. Nothing blocks saving — legacy posts fail most
of these checks and editors must stay able to fix a typo without writing a
meta description first.

English only on purpose: the front falls back to EN whenever a language is
missing (util/translateObj), so EN is what actually renders on every page.

CommonJS on purpose: seoFieldStatus.test.js runs under plain `node` without the
webpack/babel toolchain (this package has no test framework); the components
import it through babel's CJS interop.
*/

// Google truncates titles around 60 characters and descriptions around 155.
// The second number is where the field stops being merely long and starts
// losing the artist name or the date at the end.
const TITLE_LIMITS = { warn: 60, max: 70 };
const DESCRIPTION_LIMITS = { warn: 155, max: 165 };

const charCounterTier = (length, limits) => {
  if (length > limits.max) return 'over';
  if (length > limits.warn) return 'warn';
  return 'ok';
};

const englishText = (field) => {
  if (!field || typeof field !== 'object') return '';
  return typeof field.en === 'string' ? field.en.trim() : '';
};

const getPostSeoWarnings = (postInfo) => {
  const { postDescription } = postInfo || {};
  if (!postDescription) return [];

  const warnings = [];
  const url = typeof postDescription.url === 'string' ? postDescription.url.trim() : '';
  const title = englishText(postDescription.title);
  const description = englishText(postDescription.description);
  const metaTags = englishText(postDescription.metaTags);

  // "/" is what an empty RELINK is stored as, and it points the canonical at
  // the language homepage instead of at this post.
  if (url === '' || url === '/') {
    warnings.push('RELINK is empty: the page cannot declare its own canonical URL.');
  }

  if (!description) {
    warnings.push('POST DESCRIPTION (EN) is empty: it fills the meta description and the social card.');
  }

  if (!metaTags) {
    warnings.push('META TAGS (EN) is empty: recommended for search results.');
  }

  if (title && title.length > TITLE_LIMITS.max) {
    warnings.push(`TITLE (EN) is ${title.length} characters: Google truncates around ${TITLE_LIMITS.warn}.`);
  }

  return warnings;
};

module.exports = {
  TITLE_LIMITS,
  DESCRIPTION_LIMITS,
  charCounterTier,
  getPostSeoWarnings,
};
